import Bookmark from "@crehana/compass.icons.fill/Bookmark";
import Plus from "@crehana/compass.icons.outline/Plus";
const intlCategories = [
    {
        value: 'by-filter',
        title: 'Por atributos',
        icon: Plus,
        description: 'Utiliza criterios para filtrar usuarios en función de los atributos con los que han sido etiquetados.'
    },
    {
        value: 'saved-filters',
        title: 'Filtros guardados',
        icon: Bookmark,
        description: 'Accede aquí a las vistas guardadas para segmentar información rápidamente.'
    }
];
const tabs = [
    {
        key: 'dashboard-filters-period-last-tab',
        label: 'Alfabetico',
        value: 'alphabetical'
    },
    {
        key: 'dashboard-filters-period-specific-tab',
        label: 'Numerico',
        value: 'numeric'
    },
    {
        key: 'dashboard-filters-period-range-tab',
        label: 'Fecha',
        value: 'date'
    }
];
const items = [
    {
        id: 'f9f8a174-1278-44d3-af2e-abd9b5887851',
        categoryItem: 'objetivo',
        type: 'TEXT',
        edges: [
            'mejorar performance',
            'llegar lejos',
            'adelantar avances',
            'mejorar metricas',
            'superar mes anterior'
        ]
    },
    {
        id: '09b301cc-8784-4818-b4e9-9995e9a6bb63',
        categoryItem: 'codigo',
        type: 'NUMBER',
        edges: []
    },
    {
        id: '437bf2f0-1113-4916-9e54-5656577e3791',
        categoryItem: 'número favorito',
        type: 'NUMBER',
        edges: []
    },
    {
        id: 'f5f40fc7-9b28-46f7-947b-0a9a4adb96c4',
        categoryItem: 'Fecha primer logro',
        type: 'DATE',
        edges: []
    },
    {
        id: 'c3802c2a-cf2d-42d2-aa2f-4e617ef2fcb3',
        categoryItem: 'PAIS',
        type: 'LIST',
        edges: [
            'brasil',
            'perú',
            'colombia',
            'argentina',
            'nicaragua',
            'canada',
            'bolivia',
            'paraguay',
            'el salvador',
            'uruguay',
            'venezuela',
            'honduras'
        ]
    },
    {
        id: '5ac96070-09e3-4925-b9de-9f21a40f49dd',
        categoryItem: 'departamento',
        type: 'LIST',
        edges: [
            'tech',
            'seguridad informatica',
            'contabilidad',
            'finanzas',
            'marketing',
            'legal',
            'compras y adquisiciones',
            'servicio al cliente',
            'investigación y desarrollo',
            'ventas'
        ]
    },
    {
        id: 'a42411bf-f100-454b-a220-2836197f2281',
        categoryItem: 'Direccion',
        type: 'TEXT',
        edges: [
            'la encenada',
            'puente piedra',
            'san juan de miraflores',
            'san juan de lurigancho',
            'los olivos'
        ]
    },
    {
        id: '4ff04b7d-e1ad-4edc-b8b0-e7e397457349',
        categoryItem: 'barrio',
        type: 'TEXT',
        edges: [
            'san juan de dios',
            'alisos',
            'las gardenias',
            'san juadas tadeo',
            'san luis'
        ]
    },
    {
        id: '8d62eb73-bb5d-4232-8454-3021e099d5b4',
        categoryItem: 'Fecha Ingreso',
        type: 'DATE',
        edges: []
    },
    {
        id: '509710f9-422b-4441-8c1a-8bf36f23b2be',
        categoryItem: 'equipo',
        type: 'LIST',
        edges: [
            'raichu',
            'slowpoke',
            'new two',
            'pikachu',
            'bulbasaur',
            'snorlax',
            'charizard'
        ]
    },
    {
        id: '136f2a53-10f1-4ac5-8cbb-c4a42925d615',
        categoryItem: 'atributo 1',
        type: 'LIST',
        edges: [
            'opcion 1',
            'opcion 3',
            'opcion 2'
        ]
    },
    {
        id: 'ab511d92-ae1e-4fb9-bb83-1aae609ca821',
        categoryItem: 'opcion 2',
        type: 'LIST',
        edges: [
            'linea 1',
            'linea 3',
            'linea 2'
        ]
    }
];
export { intlCategories, items, tabs };
